import React from 'react'
import GlobalImports from "./shared/GlobalImports"
import Header from "./navigation/Header"
import Sidenav from "./navigation/Sidenav"

export default function App({ appProps, children }) {

  return (
    <>
      <GlobalImports appProps={ appProps } />
      <Header
        appProps={ appProps }
      />

      <div className='main-content'>
        <Sidenav
          appProps={ appProps }
        />
        <div className='flex-box flex-column main-wrapper'>
          { children }
          <div className='legal flex-box flex-column' style={{ marginTop: 80, padding: '0px 20px' }}>
            <div className='legal-links flex-box' style={{ gap: 20 }}>
              <a href={ appProps.termsUrl } className='' rel='nofollow noindex nofollow'>
                { Cas.translations.terms }
              </a>
              <a href={ appProps.privacyUrl } className='' rel='nofollow noindex nofollow'>
                { Cas.translations.privacyPolicy }
              </a>
            </div>
            <div className='copyrights' style={{ marginTop: 10 }}>
              © Copyright {new Date().getFullYear()}. Powered by {appProps.instanceName}.
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
